import { z } from 'zod'

export const flightZodSchema = z.object({
  // from: z.string().nonempty({ message: 'error.from.location' }),
  // to: z.string().nonempty({ message: 'error.to.location' }),
  departure: z.any(),
  // return: z.string().optional(),
  // adults: z.string().nonempty({ message: 'error.adults' }),
})

export type flightType = z.infer<typeof flightZodSchema>
